import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reportesupervisor',
  templateUrl: './reportesupervisor.component.html',
  styleUrls: ['./reportesupervisor.component.css']
})
export class ReportesupervisorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
